/**
 * Institution Insumos Service — gestion del aprovisionamiento de
 * study_types y priorities por IPS desde el SUPER_ADMIN.
 */

import { get, post, del } from '@/lib/api'
import { API_ROUTES } from '@/config/constants'

export interface InstitutionStudyType {
  id: string
  code: string
  name: string
  description: string | null
  isActive: boolean
  displayOrder: number
  institutionId: string | null
  createdAt: string
  updatedAt: string | null
  deletedAt: string | null
}

export interface InstitutionPriority {
  id: string
  code: string
  name: string
  color: string
  textColor: string
  sortOrder: number
  isDefault: boolean
  isActive: boolean
  institutionId: string | null
  createdAt: string
  updatedAt: string
}

export interface CreateStudyTypeInput {
  code: string
  name: string
  description?: string
  displayOrder?: number
  isActive?: boolean
}

export interface CreatePriorityInput {
  code: string
  name: string
  color: string
  textColor?: string
  sortOrder: number
  isDefault?: boolean
}

// Study types
export const listInstitutionStudyTypes = (
  institutionId: string
): Promise<{ studyTypes: InstitutionStudyType[] }> =>
  get(API_ROUTES.INSTITUTIONS.STUDY_TYPES(institutionId))

export const createInstitutionStudyType = (
  institutionId: string,
  data: CreateStudyTypeInput
): Promise<{ studyType: InstitutionStudyType }> =>
  post(API_ROUTES.INSTITUTIONS.STUDY_TYPES(institutionId), data)

export const deleteInstitutionStudyType = (
  institutionId: string,
  resourceId: string
): Promise<{ message: string }> =>
  del(API_ROUTES.INSTITUTIONS.STUDY_TYPE_DETAIL(institutionId, resourceId))

// Priorities
export const listInstitutionPriorities = (
  institutionId: string
): Promise<{ priorities: InstitutionPriority[] }> =>
  get(API_ROUTES.INSTITUTIONS.PRIORITIES(institutionId))

export const createInstitutionPriority = (
  institutionId: string,
  data: CreatePriorityInput
): Promise<{ priority: InstitutionPriority }> =>
  post(API_ROUTES.INSTITUTIONS.PRIORITIES(institutionId), data)

export const deleteInstitutionPriority = (
  institutionId: string,
  resourceId: string
): Promise<{ message: string }> =>
  del(API_ROUTES.INSTITUTIONS.PRIORITY_DETAIL(institutionId, resourceId))
